$(window).on('load', function () {

});

$(document).on('click', '.metaproducts_ele .variant-input', function(event) {
    var vl = $(this).attr('data-value');
    $('.arne-color-swatch-element').removeClass('disabled_div');
    $('.arne-color-swatch-element').each(function() {
      var x = JSON.parse($(this).find('script').html());
      var that = $(this);
      var vav = false;
    
      var hr = that.attr('rel_handle');
      x.forEach(function(v, i) {
        if (v.option1 == vl || v.option2 == vl || v.option3 == vl) {
          if (v.available) {} else {
            that.addClass('disabled_div');
          }
          vav = true;
          if (that.hasClass('active')) {} else {
            var hrl = hr+'?variant='+v.id;

            if (vl == v.title) {
              that.find('a').attr('href', hrl);
            }
          }
        }
      });
      if (vav) {
      } else {
        that.addClass('disabled_div');
      }
    });
});

$(document).ready(function() {
  $(document).on("change",".custom_complentary_product_select",function(){
    var v = $(this).val();
    $(this).parents('.select_cst_btn').find('input[name="id"]').val(v);
  })
  $('summary.menu-drawer__menu-item').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
  });
  
  $(document).on('click', '.customer a[href="#recover"]', function() {
    $('.log').hide();
    $('.rec').show();
  });

  $(document).on('click', '.customer a[href="#login"]', function() {
    $('.log').show();
    $('.rec').hide();
  });
  
  // $(document).on('click', '.personal_info_show', function() {
  //   $('.customer_order_and_info .customer_info').show();
  //   $('.customer_orders').hide();
  //   $('.cst_accounts-tab li').removeClass('active');
  //   $(this).addClass('active');
  // });
  
  // $(document).on('click', '.orders_info_show', function() {
  //   $('.customer_order_and_info .customer_info').hide();
  //   $('.customer_orders').show();
  //   $('.cst_accounts-tab li').removeClass('active');
  //   $(this).addClass('active');
  // });
  
  $('.togglepassword').click(function() {
    $(this).toggleClass('active');  
    var iptype = $(this).siblings('input').attr('type');
    if (iptype == 'password') {
      $(this).siblings('input').attr('type', 'text');
    } else {
      $(this).siblings('input').attr('type', 'password');
    }
  });
  
  $(".handle-collapse-model-wears a").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    var index = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $('li[data-media-index="'+index+'"]').offset().top - 70
    }, 1000);
    var i = $('li[data-media-index="'+index+'"]').position();
    $('.product__media-list.contains-media').scrollLeft(i.left);
  });
  
  $('.list-social__link span').removeClass('visually-hidden');
  $('.list-social__link svg').hide();
  
  $('.maebe-faq .accordion').click(function() {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });

    $(document).on('click', '.modal-toggle', function(e) {
    e.preventDefault();
    $('.modal').toggleClass('is-visible');
  });
  $(window).on("resize", function (e) {
    checkScreenSize();
  });
  
  checkScreenSize();
  
  function checkScreenSize(){
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 768) {
    }
  }
  
  $('button.closenewsletter').click(function() {
    $('.newletter_wrp_popup').hide();
  });
  
  $('.slider--desktop_ele.owl-carousel').owlCarousel({
    loop: false,
    responsiveClass: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1,
        stagePadding: 50
      },
      600: {
        items: 4
      }
    },
    nav: true,
    margin: 4,
    dots: false
  });
  $('.slider--desktop_ele.owl-carousel .owl-prev').html('<p class="dflexarrows"><span>←</span><span>Back</span></p>');
  $('.slider--desktop_ele.owl-carousel .owl-next').html('<p class="dflexarrows"><span>Next</span><span>→</span></p>');


  $('form#customer_login button').click(function(e) {
    e.preventDefault();
    var em = $(this).parents('form').find('input#CustomerEmail').val();
    var pas = $(this).parents('form').find('input#CustomerPassword').val();
    if (em == '') {
      $(this).parents('form').find('input#CustomerEmail').addClass('error');
      setTimeout(() => {        
        $(this).parents('form').find('input#CustomerEmail').removeClass('error');
      },500);
      return;
    }
    
    $(this).parents('form').find('input#CustomerEmail').removeClass('error');
    if (pas == '') {      
      $(this).parents('form').find('input#CustomerPassword').addClass('error');
      setTimeout(() => {        
        $(this).parents('form').find('input#CustomerEmail').removeClass('error');
        $(this).parents('form').find('input#CustomerPassword').removeClass('error');
      },500);
      return;
    }
    $(this).parents('form#customer_login').submit();
  });
  
    var choices = document.querySelectorAll('.product-form__input--pill input[type=radio]+label');
    var maxWidth = 0;
    // read
    for (var i = 0; i < choices.length; ++i) {
        maxWidth = Math.max(maxWidth, choices[i].offsetWidth)
    };
    
    // write
    for (var i = 0; i < choices.length; ++i) {
        choices[i].style.width = maxWidth + "px";
    };   
});
                  